import { render, staticRenderFns } from "./ArticlesAdmin.vue?vue&type=template&id=f58e01ca"
import script from "./ArticlesAdmin.vue?vue&type=script&lang=js"
export * from "./ArticlesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports